import React, { useEffect } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { setAuthToken, clearAuthToken } from "../api/Client/apiClient";

// AuthProvider component that sets up global authentication
const AuthProvider = ({ children }) => {
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    console.log(
      "AuthProvider effect - initialized:",
      initialized,
      "keycloak:",
      !!keycloak
    );
    if (initialized && keycloak) {
      console.log(
        "Keycloak authenticated:",
        keycloak.authenticated,
        "has token:",
        !!keycloak.token
      );
      if (keycloak.authenticated && keycloak.token) {
        // Set the token globally when user is authenticated
        setAuthToken(keycloak.token);
        console.log("Auth token set globally");
      } else {
        // Clear the token when user is not authenticated
        clearAuthToken();
        console.log("Auth token cleared globally");
      }
    }
  }, [keycloak, initialized]);

  // Proactive refresh using refresh token at a regular cadence and on events
  useEffect(() => {
    if (!initialized || !keycloak) return;

    let intervalId = null;

    const tryRefresh = async () => {
      try {
        const refreshed = await keycloak.updateToken(60);
        if (refreshed && keycloak.token) {
          setAuthToken(keycloak.token);
          console.log("Token refreshed successfully");
        }
      } catch (error) {
        console.warn("Background token refresh failed:", error);
      }
    };

    // Refresh every 30s if needed (threshold 60s inside updateToken)
    intervalId = window.setInterval(tryRefresh, 30000);

    // Also refresh immediately when Keycloak signals expiry
    const previousOnTokenExpired = keycloak.onTokenExpired;
    keycloak.onTokenExpired = () => {
      console.log("Token expired, attempting refresh...");
      tryRefresh();
      if (typeof previousOnTokenExpired === "function") {
        try {
          previousOnTokenExpired();
        } catch (_) {}
      }
    };

    // Refresh when tab regains focus/visibility
    const onVisibilityChange = () => {
      if (!document.hidden) {
        tryRefresh();
      }
    };
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      if (intervalId) window.clearInterval(intervalId);
      document.removeEventListener("visibilitychange", onVisibilityChange);
      // best-effort restore
      keycloak.onTokenExpired = previousOnTokenExpired;
    };
  }, [keycloak, initialized]);

  return children;
};

export default AuthProvider;
